import { useCallback, useEffect, useRef, useState } from "react";

// 浏览器录音（MediaRecorder，webm/opus 优先，Safari 回退 mp4）：{ rec, sec, start, stop, supported }
export function useRecorder({ maxSec = 120, onBlob }) {
  const [rec, setRec] = useState(false);
  const [sec, setSec] = useState(0);
  const mr = useRef(null);
  const chunks = useRef([]);
  const timer = useRef(null);
  const cb = useRef(onBlob);
  cb.current = onBlob;
  const supported = typeof navigator !== "undefined" && !!navigator.mediaDevices?.getUserMedia && typeof MediaRecorder !== "undefined";

  const stop = useCallback(() => {
    clearInterval(timer.current);
    if (mr.current && mr.current.state !== "inactive") mr.current.stop();
    setRec(false);
  }, []);

  useEffect(() => () => { clearInterval(timer.current); try { mr.current?.stream?.getTracks().forEach((t) => t.stop()); } catch {} }, []);

  const start = useCallback(async () => {
    if (!supported) return "unsupported";
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const type = ["audio/webm;codecs=opus", "audio/webm", "audio/mp4"].find((t) => MediaRecorder.isTypeSupported(t)) || "";
      const m = new MediaRecorder(stream, type ? { mimeType: type } : undefined);
      chunks.current = [];
      m.ondataavailable = (e) => { if (e.data?.size) chunks.current.push(e.data); };
      m.onstop = () => { stream.getTracks().forEach((t) => t.stop()); cb.current?.(new Blob(chunks.current, { type: m.mimeType || type || "audio/webm" })); };
      m.start(1000);
      mr.current = m; setRec(true); setSec(0);
      timer.current = setInterval(() => setSec((s) => { if (s + 1 >= maxSec) stop(); return s + 1; }), 1000);
      return null;
    } catch (e) { return "denied"; }
  }, [supported, maxSec, stop]);

  return { rec, sec, start, stop, supported };
}
